export default {
  'movementOsXFinancial.form.selectReportType': 'Select report type',
  'movimentOsXFinancial.form.reportType.noFinancialDivergentValue': 'No Financial / Divergent Value',
  'movimentOsXFinancial.form.reportType.overview': 'Overview',
  'movimentOsXFinancial.form.reportType.filterByDateFrom': 'Filter by date',
  'movimentOsXFinancial.form.reportType.delivery': 'Delivery',
  'movimentOsXFinancial.form.reportType.authorization': 'Authorization',
  'movimentOsXFinancial.form.reportType.closure': 'Closure',
  'movimentOsXFinancial.form.reportType.compareDivergentValue': 'Compare the divergent value of the OS with the value of the installment',
  'movimentOsXFinancial.form.reportType.grossValue': 'Gross Value',
  'movimentOsXFinancial.form.reportType.netValue': 'Net Value',
  'movimentOsXFinancial.form.reportType.onlyTtheUnregistered': 'Only OS without financial registration',
  'movimentOsXFinancial.form.overview.filterByDate.os': 'OS',
  'movimentOsXFinancial.form.overview.filterByDate.financial': 'Financial',
  'movimentOsXFinancial.form.overview.filterBudgetBy': 'Filter Budget By',
  'movimentOsXFinancial.form.overview.filterBudgetBy.delivery': 'Delivery',
  'movimentOsXFinancial.form.overview.filterBudgetBy.authorization': 'Authorization',
  'movimentOsXFinancial.form.overview.filterBudgetBy.closure': 'Closure',
  'movimentOsXFinancial.form.overview.filterBudgetBy.issue': 'Issue',
  'movimentOsXFinancial.form.overview.filterBudgetBy.dueDate': 'Due Date',
  'movimentOsXFinancial.form.overview.filterBudgetBy.receipt': 'Receipt',
  'movimentOsXFinancial.form.overview.moreOptions.title': 'More Options',
  'movimentOsXFinancial.form.overview.moreOptions.employees': 'Employees',
  'movimentOsXFinancial.form.overview.moreOptions.documentType': 'Document Type',
};

